export default "__VITE_ASSET__B46nSxzd__"